/**
 * Scroll progress 0 → 1 while the element crosses the viewport.
 */
export const SCROLL_REVEAL_OFFSET = [
  'start 0.95',
  'end 0.2',
] as const;

export const SCROLL_REVEAL_HEADLINE_OFFSET = [
  'start 0.9',
  'end 0.1',
] as const;

export const SCROLL_HEADLINE_Y = 56;
export const SCROLL_HEADLINE_Y_EXIT = 32;
export const SCROLL_HEADLINE_BLUR = 20;
export const SCROLL_HEADLINE_BLUR_EXIT = 16;

/** Optional light fade for body copy — no blur */
export const SCROLL_CONTENT_Y = 24;
export const SCROLL_CONTENT_Y_EXIT = 16;

export type ScrollRevealVariant = 'headline' | 'content';

export interface ScrollRevealConfig {
  offset: readonly [string, string];
  yEnter: number;
  yExit: number;
  blurEnter: number;
  blurExit: number;
  opacityIn: number;
  opacityOut: number;
}

export const SCROLL_REVEAL_VARIANTS: Record<ScrollRevealVariant, ScrollRevealConfig> = {
  /** Große Headlines — blur rein/raus */
  headline: {
    offset: SCROLL_REVEAL_HEADLINE_OFFSET,
    yEnter: SCROLL_HEADLINE_Y,
    yExit: SCROLL_HEADLINE_Y_EXIT,
    blurEnter: SCROLL_HEADLINE_BLUR,
    blurExit: SCROLL_HEADLINE_BLUR_EXIT,
    opacityIn: 0.22,
    opacityOut: 0.8,
  },
  /** Fließtext — nur fade + leichte Y, kein blur */
  content: {
    offset: SCROLL_REVEAL_OFFSET,
    yEnter: SCROLL_CONTENT_Y,
    yExit: SCROLL_CONTENT_Y_EXIT,
    blurEnter: 0,
    blurExit: 0,
    opacityIn: 0.35,
    opacityOut: 0.85,
  },
};
